export default __webpack_public_path__ + "static/media/gr.f4f1efd0.svg";